import styled from 'styled-components';

export const MorePrintContainer = styled.section`
  padding: 20px 0 20px 0;
  border-top: 1px solid hsl(0deg, 0%, 0%, 10%);
  margin-top: 12px;
`;

export const MorePrintTitle = styled.h6`
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  letter-spacing: 0.3px;
  color: rgb(0 0 0 / 60%);
  text-align: left;
  padding: 0 0 20px 10px;
`;

export const VariantCardBox = styled.div`
  flex-basis: 16%;
  flex-shrink: 0;
  margin-right: 10px;
  margin-left: 10px;
  padding-bottom: 6px;
  cursor: pointer;

  @media (max-width: 720px) {
    flex-basis: 22%;
    cursor: default;
  }
  img {
    width: 100%;
    height: 100%;
    max-height: 86px;
    max-width: 86px;
  }

  h6 {
    text-transform: uppercase;
    font-size: 11px;
    color: hsl(0deg, 0%, 0%, 70%);
    font-weight: 500;
    margin: auto;
    text-align: center;
    padding-top: 4px;
    color: ${(props) => (props.highlight ? '#ef4e5e' : '000')};
  }
`;

export const SelectDiaperButton = styled.button`
  font-family: 'Montserrat';
  background: #ef4e5e;
  border: none;
  outline: none;
  color: #fff;
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  height: 42px;
  width: 100%;
  text-transform: uppercase;
  border-radius: 6px;
  margin: 4px auto 14px;
  max-width: 80%;
  display: block;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  @media (max-width: 720px) {
    margin: 0;
    border-radius: 0;
    cursor: default;
    max-width: 100%;
  }
`;
